import PromotionalNavigation2AcrossMobile from './PromotionalNavigation2AcrossMobile.component';

export default PromotionalNavigation2AcrossMobile;
